import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { TeamLogo, FormBadges } from "./TeamBits";

function StatusBadge({ match }) {
  if (match.status === "live")
    return (
      <span className="flex items-center gap-1.5 text-[#FF3B30] font-bold mono text-[11px]">
        <span className="live-dot" /> {match.minute || match.status_detail}
      </span>
    );
  if (match.status === "finished") return <span className="label text-[10px]">FINITA</span>;
  if (match.status === "postponed") return <span className="label text-[10px] text-[#FFCC00]">RINVIATA</span>;
  const t = new Date(match.kickoff).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" });
  return <span className="mono text-[12px] font-bold text-white">{t}</span>;
}

function TeamRow({ team, score, side }) {
  return (
    <div className="flex items-center gap-3">
      <TeamLogo team={team} size={28} />
      <div className="min-w-0 flex-1">
        <div className="heading text-lg font-bold truncate leading-tight">{team.name}</div>
      </div>
      <FormBadges form={team.form} testId={`form-${side}`} />
      <div className="mono text-xl font-black w-6 text-right">{score ?? ""}</div>
    </div>
  );
}

export default function MatchCard({ match, index = 0 }) {
  return (
    <Link
      to={`/match/${encodeURIComponent(match.id)}`}
      data-testid={`match-card-${match.id}`}
      className={`fade-up block surface-raised hover:border-[#39FF14]/40 transition-colors ${match.status === "live" ? "border-[#FF3B30]/40" : ""}`}
      style={{ animationDelay: `${Math.min(index, 20) * 30}ms` }}
    >
      <div className="p-5">
        <div className="flex items-center justify-between mb-4">
          <span className="label text-[10px] truncate">{match.league.name}</span>
          <StatusBadge match={match} />
        </div>
        <div className="space-y-3">
          <TeamRow team={match.home} score={match.score.home} side="home" />
          <TeamRow team={match.away} score={match.score.away} side="away" />
        </div>
        <div className="mt-4 pt-3 border-t border-[#27272A] flex items-center gap-1.5 text-[11px] text-[#A1A1AA]">
          <MapPin size={12} strokeWidth={1.5} />
          <span className="truncate">{[match.stadium.name, match.stadium.city].filter(Boolean).join(" · ") || "Stadio n/d"}</span>
        </div>
      </div>
    </Link>
  );
}
